/**
 * Predefined loader messages for consistent user experience
 * All messages in Norwegian (nb)
 */
export enum LoaderMessage {
  LOADING = 'Laster...',
  FETCHING_DATA = 'Henter data...',
  DOWNLOADING_CARD = 'Laster ned gavekort...',
  CREATING_ORDER = 'Oppretter ordre...',
  TO_VIPPS = 'Sender deg til Vipps...',
}
